import type { ComponentProps } from 'react';

import { cn } from '@/lib/shadcn/utils';

/**
 * A failed action's message, rendered where the user acted: under the form,
 * inside the dialog. `role="alert"` announces it the moment it appears.
 */
export function InlineError({ className, ...props }: ComponentProps<'p'>) {
  return (
    <p
      className={cn('text-destructive text-[13px] leading-[18px]', className)}
      role="alert"
      {...props}
    />
  );
}
